/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import costIcon from "../../../assets/icons/serviceOverview/IconCosts";
import ContentBox from "../../Box/ContentBox/ContentBox";
import SettlementCosts from "./SettlementCosts";
import { CostBoxLoader } from "../../ContentLoader/CostBoxLoader";
import { AbstractCase } from "../../../types/Entities/AbstractCase";

type CostBoxProps = {
  settlement: AbstractCase;
}

const CostBox = ({ settlement }: CostBoxProps) => {
  if (settlement.isInitialProxy || (settlement.noWinNoFee && !settlement.nWnFAmount)) {
    return null;
  }

  return (
    <ContentBox icon={costIcon} headline={"Abfindung & Kosten"} loading={!settlement}>
      {!settlement ? <CostBoxLoader /> : <SettlementCosts settlement={settlement} />}
    </ContentBox>
  );
};

export default CostBox;
